// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"5293df73","270":"18c2e941","404":"8ec4b6ea","498":"8056c98c","553":"55a7d5e9","639":"7a5b810f","694":"17bbb29d","725":"56c4f9d0"}[chunkId] + ".chunk.js";
};